export enum CalendarEnum {
  Single = 'single',
  Multiple = 'multiple',
  Range = 'range',
}